export default "__VITE_ASSET__CBcIW4KY__"